import {Service} from 'typedi';
import type {SearchApiDocument} from '../../../../api/model/response/documents/SearchResult';
import type {CardTypeStrategyData} from '../../types/card-strategy-data.type';
import {StrategyBuilder} from '../../StrategyBuilder';
import {CardStrategyService} from '../../CardStrategyService';


@Service({id: 'cardTypeFallbackStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<CardStrategyService> {

  build(details:CardTypeStrategyData): CardStrategyService {
      return new CardStrategyFallback(details);
  }
}

export class CardStrategyFallback extends CardStrategyService {
  details;

  constructor(details:CardTypeStrategyData) {
      super();
      this.details = details;
  }

  makeCard(doc:SearchApiDocument) {
      if (doc.source === 'BSL_DOC'){
        return 'uiaas-search-result-document-v1';
      } 
      if (doc.source === 'FAQ_BFO' || doc.source === 'FAQ_China'){
        return 'uiaas-search-result-faq-v2';
      }

      return 'uiaas-search-result-card';
  }

  getCardProps(doc: SearchApiDocument, params: Record<string, string>): Record<string, string> {
      if (this.details?.params) {
        return this.details.params;
      }
      return {};
  }
}
